import React from 'react';
import NewsletterSignupMUI from './components/NewsletterSignupMUI';

export default function App() {
    return (
        <div style={{ background: 'transparent', padding: 8, display: 'flex', justifyContent: 'center' }}>
            <NewsletterSignupMUI
                apiUrl="/api/newsletter/subscribe"
                recaptchaSiteKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                title="Newsletter abonnieren"
                compact={false}
            />
        </div>
    );
}